<ng-template fhirCardOutlet></ng-template>
